module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1505-cc49d781fc8949a993c8d16b7cfd55fd.png";